import ExperiencesPage from "./ExperiencesPage";

export default [
    {
        path: "/experiences",
        name: "experiences",
        component: ExperiencesPage
    }
];